import { Grid2 } from "@mui/material";
import { useRef, useState } from "react";

// Renders a Teams message body (HTML) inside an auto-resizing iframe, the same
// way mails are rendered. Height is managed with local state so several frames
// (e.g. one per reply) can coexist without sharing a single UI id.
const MessageFrame = ({ title, html, maxHeight = "60vh" }) => {
  const iframeRef = useRef(null);
  const [height, setHeight] = useState(0);

  const frameLoaded = () => {
    const el = iframeRef.current;
    if (!el) return;
    const doc = el.contentWindow.document;
    const contentHeight = Math.max(
      doc.body.scrollHeight,
      doc.documentElement.scrollHeight
    );
    setHeight(contentHeight + 30 + "px");
  };

  if (!html) return null;

  return (
    <Grid2 container {...{ sx: { maxHeight, overflow: "auto" }, size: 12 }}>
      <iframe
        title={title || "team-message"}
        ref={iframeRef}
        onLoad={frameLoaded}
        style={{ height, display: "block" }}
        srcDoc={html}
        width="100%"
        frameBorder="0"
        scrolling="no"
      />
    </Grid2>
  );
};

export default MessageFrame;
